
export const handlePrint = (contentNode, title = 'Document') => {
  if (!contentNode) return;

  // Create iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  iframe.style.visibility = 'hidden';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;

  // HTML Structure
  doc.open();
  doc.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${title}</title>
        <style>
          /* Base styles to ensure clean print */
          body {
            background-color: white;
            margin: 0;
            padding: 20px;
            -webkit-print-color-adjust: exact;
          }
          .no-print {
            display: none !important;
          }
          .MuiCard-root {
            box-shadow: none !important;
            border: none !important;
          }
        </style>
      </head>
      <body>
        <div id="print-mount"></div>
      </body>
    </html>
  `);
  doc.close();

  // Copy Styles (Stylesheets and Emotion/Styled-components)
  // 1. Link tags (external stylesheets)
  const links = document.querySelectorAll('link[rel="stylesheet"]');
  links.forEach(link => {
    const newLink = doc.createElement('link');
    newLink.rel = 'stylesheet';
    newLink.href = link.href;
    doc.head.appendChild(newLink);
  });

  // 2. Style tags (including Emotion)
  const styles = document.querySelectorAll('style');
  styles.forEach(style => {
    const newStyle = doc.createElement('style');
    newStyle.textContent = style.textContent;
    // Copy attributes if needed (e.g. data-emotion)
    Array.from(style.attributes).forEach(attr => {
      newStyle.setAttribute(attr.name, attr.value);
    });
    doc.head.appendChild(newStyle);
  });

  // Clone content
  const contentClone = contentNode.cloneNode(true);
  
  // Handle Canvas elements (cloneNode doesn't copy canvas content)
  const canvases = contentNode.querySelectorAll('canvas');
  const clonedCanvases = contentClone.querySelectorAll('canvas');
  canvases.forEach((canvas, i) => {
    const context = canvas.getContext('2d');
    if (context) {
        clonedCanvases[i].getContext('2d').drawImage(canvas, 0, 0);
    }
  });

  // Handle Form Inputs (values are not cloned by default)
  const inputs = contentNode.querySelectorAll('input, textarea, select');
  const clonedInputs = contentClone.querySelectorAll('input, textarea, select');
  inputs.forEach((input, i) => {
    if (input.type !== 'file') {
        clonedInputs[i].value = input.value;
    }
    if (input.type === 'checkbox' || input.type === 'radio') {
        clonedInputs[i].checked = input.checked;
    }
    if (input.tagName === 'SELECT') {
        clonedInputs[i].value = input.value;
    }
  });

  doc.getElementById('print-mount').appendChild(contentClone);

  // Wait for resources (images, fonts) to load
  // A simple timeout is often used, but checking images is better.
  // For simplicity and speed, we'll use a mix.
  
  const printWindow = iframe.contentWindow;

  const performPrint = () => {
    try {
      printWindow.focus();
      printWindow.print();
    } catch (e) {
      console.error("Printing failed", e);
    } finally {
      // Cleanup after print dialog closes (or slightly after)
      // Note: print() is blocking in some browsers, non-blocking in others.
      // We can't safely remove the iframe immediately in all browsers.
      // But we can leave it or remove it after a delay.
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }
  };

  // Wait a bit for styles to apply
  setTimeout(performPrint, 500);
};
